import { ApplicationLicense, ApplicationBrick, ClusterManagerBrick, ComputeServerBrick, TokenServerBrick, CloudBrick, WLSBrick, Brick } from './bricks'
import { CApplicationBrick } from './bricks/CApplicationBrick'
import { CPPApplicationBrick } from './bricks/CPPApplicationBrick'
import { JavaApplicationBrick } from './bricks/JavaApplicationBrick'
import { CSharpApplicationBrick } from './bricks/CSharpApplicationBrick'
import { PythonApplicationBrick } from './bricks/PythonApplicationBrick'
import { Scenario } from './scenarios/data'
import { MatLabApplicationBrick } from './bricks/MatLabApplicationBrick'
import { RApplicationBrick } from './bricks/RApplicationBrick'

type Dependency = [Brick, Brick, 'token'|'model']

class Architecture {
    constructor(readonly bricks: Brick[], readonly dependencies: Dependency[], readonly containerOrchestration: boolean) {

    }

    isDependency(left: Brick, right: Brick): boolean {
        for(const dependency of this.dependencies) {
            if(dependency[0] == left && dependency[1] == right) {
                return true;
            }
        }
        return false;
    }

    findDependency(left: Brick, right: Brick): Dependency|undefined {
        for(const dependency of this.dependencies) {
            if(dependency[0] == left && dependency[1] == right) {
                return dependency;
            }
        }
        return undefined;
    }

    static Create(scenario: Scenario) {
        let ts: Brick | null = null
        let cs: Brick | null = null
        let cm: Brick | null = null
        let ic: Brick | null = null
        let server: Brick | null = null    
        let clientLicense: string | undefined = undefined
        let wls: Brick | null = null
        const bricks: Brick[] = []
        const dependencies: Array<Dependency> = []
        
        if(scenario.license == 'ic') {
            server = ic = new CloudBrick()
            clientLicense = 'ic'
            bricks.push(ic)
        }
    
        if(scenario.license=='fu' || scenario.license=='fcs') {
            server = ts = new TokenServerBrick(scenario.license, scenario.os)
            clientLicense = 'tsclient'
            bricks.push(ts)
        }
    
        if(scenario.license=='cs' || scenario.license=='fcs') {
            server = cs = new ComputeServerBrick(scenario.license=='cs' ? 'cs' : 'tsclient', scenario.os, scenario.containerServer, scenario.containerOrchestration, scenario.clusterManager)
            clientLicense = 'csclient'
            bricks.push(cs)
    
            if(scenario.clusterManager) {
                server = cm = new ClusterManagerBrick(scenario.containerServer, scenario.containerOrchestration)
                clientLicense = 'cmclient'
                bricks.push(cm)
                dependencies.push([cm, cs, 'model'])
            }
    
            if(scenario.license == 'fcs') {
                dependencies.push([ts!, cs, 'token'])
            }        
        }
    
        if(scenario.license=='wlssu'|| scenario.license=='wlsuu'||scenario.license=='wlscs') {
            wls = new WLSBrick(scenario.license)
            bricks.push(wls)
    
            if(scenario.license == 'wlscs') {
                cs = new ComputeServerBrick(scenario.license, scenario.os, scenario.containerServer, scenario.containerOrchestration, scenario.clusterManager)
                bricks.push(cs)
                dependencies.push([wls, cs, 'token'])
                server = cs
                clientLicense = 'csclient'
    
                if(scenario.clusterManager) {
                    server = cm = new ClusterManagerBrick(scenario.containerServer, scenario.containerOrchestration)
                    bricks.push(cm)
                    dependencies.push([cm, cs, 'model'])
                    clientLicense = 'cmclient'
                }
            } else {
                const client: Brick = Architecture.CreateApplication(scenario.license, scenario.os, scenario.api, scenario.framework, scenario.packageManager, scenario.containerClient, scenario.containerOrchestration)
                bricks.push(client)
                server = wls
                dependencies.push([wls, client, 'token'])
            }
        }
    
        // Client application (already generated for WLS-SU and WLS-UU above)
        if(scenario.license!='wlssu'&&scenario.license!='wlsuu') {
            const isContainer = ['cs', 'wlscs', 'fcs', 'ic', 'fu'].includes(scenario.license) && scenario.containerClient
            const client: Brick = Architecture.CreateApplication((clientLicense??scenario.license) as ApplicationLicense, scenario.os, scenario.api, scenario.framework, scenario.packageManager, isContainer, scenario.containerOrchestration)
            bricks.push(client)
            if(server) {
                if(server==ts) {
                    dependencies.push([server, client, 'token'])
                } else {
                    dependencies.push([client, server, 'model'])
                }                
            }
        }
    
        return new Architecture(bricks, dependencies, scenario.containerOrchestration)
    }

    static CreateApplication(license: ApplicationLicense, os: string, api: string, framework: string, packageManager: string, isContainer: boolean, containerOrchestration: boolean): ApplicationBrick {
        switch(api) {
            case 'csharp':
                return new CSharpApplicationBrick(license, os, framework, packageManager, isContainer, containerOrchestration)
            case 'cpp':
                return new CPPApplicationBrick(license, os, framework, packageManager, isContainer, containerOrchestration)
            case 'c':
                return new CApplicationBrick(license, os, framework, packageManager, isContainer, containerOrchestration)
            case 'java':
                return new JavaApplicationBrick(license, os, framework, packageManager, isContainer, containerOrchestration)
            case 'r':
                return new RApplicationBrick(license, os, framework, packageManager, isContainer, containerOrchestration)
            case 'matlab':
                return new MatLabApplicationBrick(license, os, framework, packageManager, isContainer, containerOrchestration)
            case 'python':            
                return new PythonApplicationBrick(license, os, framework, packageManager, isContainer, containerOrchestration)
            default:
                throw('Unknown API')
        }        
    }
}


export default Architecture